import { QueryParams, axiosInstance } from './req';

export const getDeviceGroupById = async (groupId: string): Promise<any> => {
    return axiosInstance.get(`/api/device/groups/${groupId}`).then(({ data }) => data);
};

export const getDeviceGroups = async ({ page, perPage, filter }: QueryParams): Promise<any> => {
    return axiosInstance.get(`/api/device/groups`, { params: { page, perPage, filter } }).then(({ data }) => data);
};

export const createDeviceGroup = async (name: string, devicesId: string[]): Promise<any> => {
    return axiosInstance.post('/api/device/groups/create', { name, devicesId }).then(({ data }) => data);
};

export const deleteDeviceGroup = async (groupId: string): Promise<any> => {
    return axiosInstance.delete(`/api/device/groups/delete/${groupId}`).then(({ data }) => data);
};

export const updateDeviceGroupById = async (groupId: string, name: string, devicesId: string[]): Promise<any> => {
    return axiosInstance.patch(`/api/device/groups/update/${groupId}`, { name, devicesId }).then(({ data }) => data);
};
